import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useTriggerSync } from '@/hooks/use-eirsaliye';
import { RefreshCw, Search, Download } from 'lucide-react';

interface EirsaliyeSyncBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  onRefresh: () => void;
}

export function EirsaliyeSyncBar({ search, onSearchChange, onRefresh }: EirsaliyeSyncBarProps) {
  const syncMutation = useTriggerSync();

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
      <Button
        onClick={() => syncMutation.mutate()}
        disabled={syncMutation.isPending}
        className="h-10"
      >
        {syncMutation.isPending ? (
          <><RefreshCw className="w-4 h-4 mr-2 animate-spin" />Senkronize Ediliyor...</>
        ) : (
          <><Download className="w-4 h-4 mr-2" />Senkronize Et</>
        )}
      </Button>

      <div className="relative flex-1 w-full sm:max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          placeholder="Irsaliye no, bayi kodu, sube ara..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 h-10"
        />
      </div>

      <Button variant="outline" size="icon" onClick={onRefresh} className="h-10 w-10">
        <RefreshCw className="w-4 h-4" />
      </Button>
    </div>
  );
}
